<!-- ===============================
     NEWS LAYOUT WRAPPER
================================ -->
<div class="news-layout">

  <!-- ===============================
       MAIN CONTENT (70%)
  ================================ -->
  <main class="news-main">

    <!-- 🔴 ARTICLE (UNCHANGED CONTENT) -->
    <article class="news-article" *ngIf="!loading && !error">

      <!-- HEADLINE -->
      <header class="article-header">
        <h1>
          {{ city | titlecase }} Today – {{ date }} | Traffic, Power Cut & City Updates
        </h1>

        <p class="article-dek">
          Latest daily updates from {{ city | titlecase }} including traffic conditions,
          power cut status, water supply updates, Panchang timings and essential city information.
        </p>

        <div class="article-meta">
          <span>{{ city | titlecase }}</span>
          <span>•</span>
          <time>{{ date }}</time>
        </div>

        <div class="last-updated" *ngIf="lastUpdated">
          Last updated: {{ lastUpdated }}
        </div>
      </header>

      <!-- AUTHOR BOX -->
      <div class="author-box">
        <div class="author-text">
          <span class="author-label">Written by</span>
          <span class="author-name">{{ authorName }}</span>
          <p class="author-desc">
            {{ authorDescription }}
          </p>
        </div>
      </div>

      <!-- ARTICLE INTRO -->
      <section class="article-intro">
        <p>
          {{ city | titlecase }} is a major city where daily life is influenced by traffic conditions,
          power maintenance schedules, fuel prices and local civic updates.
        </p>

        <p>
          Residents across areas such as T. Nagar, Velachery, Anna Nagar and OMR
          often rely on daily city updates to plan commuting, office schedules,
          and household activities. Monitoring traffic flow, electricity status,
          fuel prices and Panchang timings helps citizens stay prepared.
        </p>
      </section>


      <!-- ADSENSE #1 -->
      <div class="ad-slot ad-inarticle">
        <ins class="adsbygoogle" style="display:block; text-align:center;" data-ad-client="ca-pub-XXXX"
          data-ad-slot="1111111111" data-ad-format="fluid" data-ad-layout="in-article">
        </ins>
      </div>

      <!-- TODAY SPECIAL -->
      <section class="article-block" *ngIf="todaySpecial">
        <div *ngIf="todaySpecial && todaySpecial.trim().length">

          <h2>Today’s Special Update</h2>

          <ul class="bullet-list">
            <li *ngFor="let item of formatBulletText(todaySpecial)">
              {{ item }}
            </li>
          </ul>

        </div>

      </section>


      <!-- CITY STATUS -->
      <section class="article-block">
        <h2>City Status Today</h2>
        <!-- TRAFFIC -->
        <div *ngIf="traffic && traffic.trim().length">

          <h3>Traffic Today in {{ city | titlecase }}</h3>

          <ul class="bullet-list">
            <li *ngFor="let item of formatBulletText(traffic)">
              {{ item }}
            </li>
          </ul>

        </div>

        <!-- POWER CUT -->
        <div *ngIf="power_cut && power_cut.trim().length">

          <h3>Power Cut Today in {{ city | titlecase }}</h3>

          <ul class="bullet-list">
            <li *ngFor="let item of formatBulletText(power_cut)">
              {{ item }}
            </li>
          </ul>

        </div>

        <!-- WATER SUPPLY -->
        <div *ngIf="water_issue && water_issue.trim().length">

          <h3>Water Supply Today in {{ city | titlecase }}</h3>

          <ul class="bullet-list">
            <li *ngFor="let item of formatBulletText(water_issue)">
              {{ item }}
            </li>
          </ul>

        </div>
      </section>


      <!-- ADSENSE #2 -->
      <div class="ad-slot ad-inarticle">
        <ins class="adsbygoogle" style="display:block; text-align:center;" data-ad-client="ca-pub-XXXX"
          data-ad-slot="2222222222" data-ad-format="fluid" data-ad-layout="in-article">
        </ins>
      </div>

      <!-- PANCHANG -->
      <section class="article-block">
        <h2>Today’s Panchang in {{ city | titlecase }}</h2>
        <ul class="astro-list">
          <li><strong>Sunrise:</strong> {{ sunrise || '-' }}</li>
          <li><strong>Sunset:</strong> {{ sunset || '-' }}</li>
          <li><strong>Tithi:</strong> {{ tithi || '-' }}</li>
          <li><strong>Rahu Kalam:</strong> {{ rahu_kalam || '-' }}</li>
          <li><strong>Yamagandam:</strong> {{ yamagandam || '-' }}</li>
        </ul>
      </section>

      <!-- PRICE LINKS -->
      <section class="article-block">
        <h2>Today’s Prices in {{ city | titlecase }}</h2>
        <ul class="finance-links">
          <li><a [routerLink]="['/', city, 'gold-rate']">Gold Rate Today in {{ city | titlecase }}</a></li>
          <li><a [routerLink]="['/', city, 'petrol-price']">Petrol and Diesel Price Today in {{ city | titlecase }}</a>
          </li>
        </ul>
      </section>

      <!-- FAQ -->
      <section class="article-block faq-section">
        <h2>Frequently Asked Questions</h2>
        <div class="faq-item">
          <h3>Is there a power cut today in {{ city | titlecase }}?</h3>
          <p>Power cut information is based on the latest available updates.</p>
        </div>
        <div class="faq-item">
          <h3>How accurate is the traffic information?</h3>
          <p>Traffic updates reflect current reports and general city conditions.</p>
        </div>
        <div class="faq-item">
          <h3>Why are Panchang timings included?</h3>
          <p>Panchang timings are followed by many households for daily planning.</p>
        </div>
      </section>

      <!-- INTERNAL LINKS -->
      <section class="article-block internal-links">
        <h2>More from DailyCity</h2>
        <ul>
          <li><a [routerLink]="['/', city, 'gold-rate']">
              Gold Rate Today in {{ city | titlecase }}
            </a></li>
          <li><a [routerLink]="['/', city, 'petrol-price']">Petrol Price Today in {{ city | titlecase }}</a></li>
          <li><a routerLink="/about">About DailyCity</a></li>
          <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
        </ul>
      </section>

    </article>

    <!-- STATES -->
    <div *ngIf="loading" class="loading">Loading today’s city updates…</div>
    <div *ngIf="error" class="error">Unable to load today’s updates.</div>

  </main>

  <!-- ===============================
       SIDEBAR (30%)
  ================================ -->
  <aside class="news-sidebar">

    <app-sidebar [city]="city"></app-sidebar>

    <div class="sidebar-card ad-box">
      <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-XXXX" data-ad-slot="3333333333"
        data-ad-format="auto" data-full-width-responsive="true">
      </ins>
    </div>

  </aside>

</div>